import { SVGProps, Ref, forwardRef } from 'react'
const SvgShieldCross = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3 .749a1.5 1.5 0 0 0-1.5 1.5v9c0 4.813 7.234 10.169 9.693 11.76a1.477 1.477 0 0 0 1.614 0c2.459-1.591 9.693-6.947 9.693-11.76v-9a1.5 1.5 0 0 0-1.5-1.5H3Z"
    />
    <path
      fill="currentColor"
      d="M16.53 6.53a.75.75 0 0 0-1.06-1.06l1.06 1.06Zm-9.06 6.94a.75.75 0 1 0 1.06 1.06l-1.06-1.06Zm8-8-8 8 1.06 1.06 8-8-1.06-1.06Z"
    />
    <path
      fill="currentColor"
      d="M7.47 6.53a.75.75 0 0 1 1.06-1.06L7.47 6.53Zm9.06 6.94a.75.75 0 1 1-1.06 1.06l1.06-1.06Zm-8-8 8 8-1.06 1.06-8-8 1.06-1.06Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShieldCross)
export default ForwardRef
